import {useState} from 'react'
import { useAuthContext } from './useAuthContext'

export const useLogin = () => {
    const [error, setError] = useState(null)
    const [isLoading, setIsLoading] = useState(null)
    const {dispatch} = useAuthContext()

    
    const login = async (email, password) => {
        setIsLoading(true)
        setError(null)


        const response = await fetch('https://got-gains.herokuapp.com/api/user/login' , {
            method: 'POST',
            headers: {'Content-Type' : 'application/json'},
            body: JSON.stringify({
                email: email,
                password: password,
            })
        })
  
        
        const json = await response.json()
        

        if(!response.ok) {
            setIsLoading(false)  
            setError(json.error)
        }

        if(response.ok) {
            setError('Login Successful')
            localStorage.setItem('user', JSON.stringify(json))
            dispatch({type: 'LOGIN', payload: json})
            setIsLoading(false)
            



        }
    }
    return {login, isLoading, error}
}